import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { SupportAgentTicket } from "@src/types/support";

export interface PatchTicketAutoTranslationResult {
  success: boolean;
  data?: SupportAgentTicket;
  error?: string;
}

export const patchTicketAutoTranslationUseCase = async (
  autoTranslateEnabled: boolean,
  ticketId: string,
): Promise<PatchTicketAutoTranslationResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.patchTicketAutoTranslation(
      namespace,
      autoTranslateEnabled,
      ticketId,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to update auto-translation setting",
      ).message,
    };
  }
};
